import React from "react"
import { ChevronDown } from "lucide-react"
import ParallaxBackground from "../common/ParallaxBackground"
import { trackButtonClick } from "../../analytics"

const Hero = ({ t }) => {
  const scrollToContact = (e) => {
    e.preventDefault()
    const contactSection = document.querySelector("#contact")
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" })
      trackButtonClick('consultation_request', 'hero_section')
    }
  }

  return (
    <ParallaxBackground
      imageUrl="/background.jpg"
      strength={0.05}
      overlayColor="bg-green-900"
      overlayOpacity="bg-opacity-40"
    >
      <div
        id="hero"
        className="relative h-screen flex items-center justify-center text-center"
      >
        <div className="container mx-auto px-6 lg:px-8 z-10">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight opacity-0 animate-fade-in-down drop-shadow-lg">
            {t.title}
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-10 opacity-0 animate-fade-in-up animation-delay-300 drop-shadow-md">
            {t.subtitle}
          </p>
          <a
            href="#contact"
            onClick={scrollToContact}
            className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-8 rounded-lg text-lg transition duration-300 ease-in-out transform hover:scale-105 opacity-0 animate-fade-in-up animation-delay-600"
          >
            {t.cta}
          </a>
        </div>
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white animate-bounce z-10">
          <ChevronDown size={48} />
        </div>
      </div>
    </ParallaxBackground>
  )
}

export default Hero
